// test1536
(1536 && 0);
